import { makeStyles } from "@material-ui/styles";

const gamePeriodStyles = makeStyles((theme) => ({
	period: {
		margin: 0
	},
	periodComplete: {
		"& .Mui-disabled": {
			color: theme.palette.gameMode.ternary
		}
	},
	periodDisabled: {
		"& .Mui-disabled": {
			color: ({ darkMode }) =>
				darkMode ? theme.palette.gameMode.secondary : "rgba(0, 0, 0, 0.28)",
			"& div": {
				background: ({ darkMode }) =>
					darkMode ? "rgba(118, 118, 118,.7)" : "rgba(0, 0, 0, .15)",
				borderRadius: "50%"
			}
		}
	},
	radioGroup: {
		justifyContent: "center",
		margin: theme.spacing(3, 0)
	}
}));

export default gamePeriodStyles;
